import { Navigate } from "react-router-dom";
import Auth from "./auth.service";
import { checkUserURLMethodAccess } from "./helper";

/**
 * Gate a route element with permission options:
 *   { mandatoryPermissions: [{module, method, actionUrl}], optionalPermissions: [...], isAlwaysAllowed: false }
 *
 * - All mandatory permissions must be granted (AND).
 * - At least one optional permission must be granted (OR), if any specified.
 * - If user not logged in, redirects to /login.
 * - If user logged in but missing perms, redirects to /access-denied.
 */
export const ProtectedRoute = ({ element, options = {} }) => {
  const { mandatoryPermissions = [], optionalPermissions = [], isAlwaysAllowed = false } = options;

  const currentUser = Auth.user;
  const userPermissions = Auth.userPermission || [];

  // No login → /login
  if (!currentUser || Object.keys(currentUser).length === 0) {
    return <Navigate to="/login" replace />;
  }

  // No permissions loaded yet → block
  if (userPermissions.length === 0 && !isAlwaysAllowed) {
    return <Navigate to="/access-denied" replace />;
  }

  if (isAlwaysAllowed) return element;

  if (mandatoryPermissions.length > 0 || optionalPermissions.length > 0) {
    const hasMandatoryAccess =
      mandatoryPermissions.length === 0 ||
      mandatoryPermissions.every((permission) =>
        checkUserURLMethodAccess(permission.module, permission.method, permission.actionUrl)
      );

    const hasOptionalAccess =
      optionalPermissions.length === 0 ||
      optionalPermissions.some((permission) =>
        checkUserURLMethodAccess(permission.module, permission.method, permission.actionUrl)
      );

    if (hasMandatoryAccess && hasOptionalAccess) return element;
  }

  return <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;
